"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCorporateAgreementSchema = exports.createCorporateAgreementSchema = exports.corporateAgreementShape = exports.corporateAgreementStatusEnum = void 0;
const zod_1 = require("zod");
exports.corporateAgreementStatusEnum = zod_1.z.enum(['ACTIVE', 'EXPIRED', 'RENEWED', 'TERMINATED']);
exports.corporateAgreementShape = {
    corporateId: zod_1.z.string().uuid(),
    agreementNumber: zod_1.z.string().min(1).max(50),
    agreementDate: zod_1.z.coerce.date(),
    validFrom: zod_1.z.coerce.date(),
    validTo: zod_1.z.coerce.date(),
    status: exports.corporateAgreementStatusEnum.optional(),
    remarks: zod_1.z.string().nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createCorporateAgreementSchema = zod_1.z.object(exports.corporateAgreementShape);
exports.updateCorporateAgreementSchema = exports.createCorporateAgreementSchema.partial();
//# sourceMappingURL=corporate-agreement.schema.js.map